import React from "react";
import { Badge, IBadgeProps } from "components/badge/Badge";
import type { IEmailCampaign } from "api/rpc/2024-04/facilityAdmin/marketing/emailCampaigns";
import {
  emailCampaignBadgeLabel,
  emailCampaignBadgeType,
} from "./emailCampaignDesignStatus";

type TEmailCampaignBadgeProps = {
  campaign: Pick<IEmailCampaign, "status">;
  className?: string;
  size?: IBadgeProps["size"];
};

export default function EmailCampaignBadge(props: TEmailCampaignBadgeProps) {
  return (
    <Badge
      type={emailCampaignBadgeType(props.campaign.status)}
      className={props.className}
      size={props.size}
    >
      {emailCampaignBadgeLabel(props.campaign.status)}
    </Badge>
  );
}
